<div class="banner">
  <h1>{{ 'sweepstakeofficialrules.page.title' | translate }}</h1>
  <div class="d-flex align-items-center">
    <img class="banner-logo" src="assets/images/Logos/RedbullsMemberPlusWhite.svg" />
    <div *ifScreenSize="screenType.Desktop">
      <fgb-card-select></fgb-card-select>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="rounded mt-3 p-3">
        <fgbcl-terms-and-conditions
          [type]="termsAndConditionsType.LoyaltyScheme"
          [defaultTerms]="defaultTemplate"
        ></fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="text-left font-size-14 mb-3">
    {{ 'default.terms.description' | translate }}
  </p>
</ng-template>
